<template>
  <div>
    <div class="apply">
      <img
        :src="imgPrex + image"
        alt=""
      >
    </div>
    <van-button
      class="btn"
      text="立即邀请"
      block
      @click="showPopup = true"
    />
    <share-popup
      :good-obj="info"
      :show-popup="showPopup"
      @hidePopup="showPopups"
    />
  </div>
</template>

<script>
import { getIntroduceImg } from "@/api/join";
import sharePopup from "@/components/share/share";
export default {
  components: {
    sharePopup,
  },
  data() {
    return {
      info: {
        name: this.$store.getters.nickname,
        shareType: "2",
      },
      showPopup: false,
      image: ""
    }
  },
  methods: {
    showPopups(bol) {
      this.showPopup = bol;
    },
  },
  created() {
    getIntroduceImg({
      type: "2"
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.image = res.content.image;
      }
    });
  }
}
</script>

<style lang="scss" scoped>
.apply {
  width: 100%;
  height: 100%;
  position: relative;
  img {
    width: 100%;
    display: block;
  }
}
.btn {
  width: 253px;
  height: 47px;
  position: fixed;
  left: 61px;
  bottom: 25px;
  font-size: 26px;
  color: #ffffff;
  background-color: #e75e1b;
  border-width: 0 !important;
  border-radius: 24px;
}
</style>